import {BaseButton, GoogleSignInButton, InvertedButton} from './button.styles.jsx';

export const BUTTON_TYPES_CLASSES = {
    base: BaseButton,
    google:"google-sign-in",
    inverted: "inverted",
};

export const getButton = (buttonType = BUTTON_TYPES_CLASSES.base) =>
    ({
        [BUTTON_TYPES_CLASSES.base]: BaseButton,
        [BUTTON_TYPES_CLASSES.google]: GoogleSignInButton,
        [BUTTON_TYPES_CLASSES.inverted]: InvertedButton,
    }[buttonType]);


export const Button = ( {children, buttonType, ...otherProps}) => {
    const CustomButton = getButton(buttonType);
    return (
        <CustomButton {...otherProps}>{children}</CustomButton>
    )
}

export default Button; 